module.exports = __webpack_public_path__ + "static/media/hiding_turtle.a3584184.png";